import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Eventos from "./pages/Eventos";
import DetalhesEvento from "./pages/DetalhesEvento";
import Carrinho from "./pages/Carrinho";
import Checkout from "./pages/Checkout";
import DashboardDono from "./pages/DashboardDono";
import DashboardAdmin from "./pages/DashboardAdmin";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import CriarEvento from "./pages/CriarEvento";
import AdminSidebar from "./components/AdminSidebar";
import DashboardEventos from "./pages/DashboardEventos";
import MeusPedidos from "./pages/MeusPedidos";
import VendasAdmin from "./pages/VendasAdmin";
import CompraPasso1 from "./pages/CompraPasso1";
import CompraPasso2 from "./pages/CompraPasso2";
import CompraPasso3 from "./pages/CompraPasso3";
import ResumoPedido from "./pages/ResumoPedido";
import Pagamento from "./pages/Pagamento";
import Confirmacao from "./pages/Confirmacao";
import TaxasAdmin from "./pages/TaxasAdmin";
import { UserProvider } from "./context/UserContext";
import Financeiro from "./pages/Financeiro";
import CheckoutCartao from "./components/CheckoutCartao";
import VendasDono from "./pages/VendasDono"; // importe a página de vendas dono
import SidebarDono from "./components/SidebarDono";
import Clientes from "./pages/Clientes";
import Donos from "./pages/Donos";
import FinanceiroAdmin from "./pages/FinanceiroAdmin";
import FinanceiroDono from "./pages/FinanceiroDono";
import QuemSomos from "./pages/QuemSomos";
import ComoContratar from "./pages/ComoContratar";
import BotaoWhatsApp from './components/BotaoWhatsApp';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './styles/donoLayout.css';
import ConfirmacaoPagamento from "./pages/ConfirmacaoPagamento";
import RecuperarSenha from './pages/RecuperarSenha';
import ResetarSenha from './pages/ResetarSenha';
import PoliticaCancelamento from "./pages/PoliticaCancelamento";
import PerfilUsuario from "./pages/PerfilUsuario";
import Vaquejadas from "./pages/Vaquejadas";
import RelatorioDono from './pages/Relatorio';
import Contato from "./pages/Contato";
import AvisosAdmin from "./pages/AvisosAdmin";
import ScrollToTop from "./components/ScrollToTop";
import ConfigPushcut from "./pages/ConfigPushcut";
import EditarEvento from "./pages/EditarEvento";
import RelatorioAdmin from "./pages/RelatorioAdmin";
import SenhasLimpas from "./pages/SenhasLimpas";
import SenhasLimpasDono from "./pages/SenhasLimpasDono";
import Ranking from "./pages/Ranking";
import RankingDetalhes from "./pages/RankingDetalhes";
import CircuitosAdmin from "./pages/CircuitosAdmin";
import TransferirSenha from "./pages/TransferirSenha";
import ExportacaoEventoAdmin from "./pages/ExportacaoEventoAdmin";
import Gateways from "./pages/Gateways";
import DespesasAdmin from "./pages/DespesasAdmin";
import ValesAdmin from "./pages/ValesAdmin";
import DescontosAdmin from "./pages/DescontosAdmin";
import NotificacaoWhatsapp from "./pages/NotificacaoWhatsapp";
import ContabilidadeAdmin from "./pages/ContabilidadeAdmin";
import RaspadinhaAdmin from "./pages/RaspadinhaAdmin"; 
import RaspadinhaVendasAdmin from "./pages/RaspadinhaVendasAdmin";
import PatrocinadoresAdmin from "./pages/PatrocinadoresAdmin";
import MarketingAdmin from "./pages/MarketingAdmin";
import ProfissionaisAdmin from "./pages/ProfissionaisAdmin"
import ProfissionalAcesso from "./pages/ProfissionalAcesso";
// ✅ NOVO PAINEL
import PainelEntrada from "./pages/PainelEntrada";
import PainelRodizio from "./pages/PainelRodizio";
import PainelDisputa from "./pages/PainelDisputa";
import PainelPlacarEntrada from "./pages/PainelPlacarEntrada";
import PlacarClassificacao from "./pages/PlacarClassificacao";
import PlacarDisputa from "./pages/PlacarDisputa";
import LayoutCircuito from "./pages/circuito/LayoutCircuito"
import CircuitoHomeV2 from "./pages/circuito/CircuitoHomeV2"
import CircuitoRegulamento from "./pages/circuito/CircuitoRegulamento"
import CircuitoRanking from "./pages/circuito/CircuitoRanking"
import CircuitoInscreverSe from "./pages/circuito/CircuitoInscreverSe"
import DashboardCircuito from "./pages/painelCircuito/DashboardCircuito"
import LayoutPainelCircuito from "./pages/painelCircuito/LayoutPainelCircuito"
import CircuitoNoticiasPainel from "./pages/painelCircuito/CircuitoNoticiasPainel"
import CircuitoNoticiaDetalhe from "./pages/circuito/CircuitoNoticiaDetalhe"
import CircuitoNoticiasLista from "./pages/circuito/CircuitoNoticiasLista"
import CircuitoCampeoesPainel from "./pages/painelCircuito/CircuitoCampeoesPainel"
import CircuitoEtapasPainel from "./pages/painelCircuito/CircuitoEtapasPainel"
import CircuitoInscricaoAcesso from "./pages/circuito/CircuitoInscricaoAcesso"
import CircuitoInscricaoDados from "./pages/circuito/CircuitoInscricaoDados"
import CircuitoInscricaoPagamento from "./pages/circuito/CircuitoInscricaoPagamento"
import AssociadosCircuito from "./pages/painelCircuito/AssociadosCircuito";
import CircuitoCavalos from "./pages/painelCircuito/CircuitoCavalos";
import CircuitoInscricaoCadastro from "./pages/circuito/CircuitoInscricaoCadastro"
import CircuitoPatrocinadoresPainel from "./pages/painelCircuito/CircuitoPatrocinadoresPainel";
import CircuitoEtapas from "./pages/circuito/CircuitoEtapas"
import CircuitoFinanceiroPainel from "./pages/painelCircuito/CircuitoFinanceiroPainel"; // 👈 NOVO
import FinanceiroCircuitoAdmin from "./pages/FinanceiroCircuitoAdmin"; // 👈 NOVO
import CircuitoAfiliadosPainel from "./pages/painelCircuito/CircuitoAfiliadosPainel";
import CircuitoInscricaoSucesso from "./pages/circuito/CircuitoInscricaoSucesso"
import CircuitoAfiliadoDashboard from "./pages/circuito/CircuitoAfiliadoDashboard";
import LoginPainelCircuito from "./pages/painelCircuito/LoginPainelCircuito";
import MinhaAssociacaoCircuito from "./pages/circuito/MinhaAssociacaoCircuito"
import EditarAssociadoCircuito from "./pages/painelCircuito/EditarAssociadoCircuito";
import AfiliadosAdmin from "./pages/AfiliadosAdmin";
import RecuperarSenhaCircuito from './pages/circuito/RecuperarSenha';
import ResetarSenhaCircuito from './pages/circuito/ResetarSenha';
import CircuitoRankingPainel from "./pages/painelCircuito/CircuitoRankingPainel";
import MapaCompartilhado from "./pages/MapaCompartilhado";
import CircuitoRegulamentoPainel from "./pages/painelCircuito/CircuitoRegulamentoPainel";
import CircuitoCarteirinha from "./pages/circuito/CircuitoCarteirinha";
import DespesasCircuitoAdmin from "./pages/DespesasCircuitoAdmin";
import CircuitoDespesasPainel from "./pages/painelCircuito/CircuitoDespesasPainel";
import CircuitoCuponsPainel from "./pages/painelCircuito/CircuitoCuponsPainel";
import TransmissaoCircuito from "./pages/painelCircuito/TransmissaoCircuito";
import NotificacaoApp from "./pages/NotificacaoApp";
import GerenciarTransmissoes from "./pages/GerenciarTransmissoes";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import PainelParcelamentos from "./pages/admin/PainelParcelamentos"
import MeusBoletos from "./pages/MeusBoletos";

// 💡 DICIONÁRIO DE DOMÍNIOS EXCLUSIVOS (White-label)
const customDomains = {
  "campeonatoportinha.com": "portinha",
  "www.campeonatoportinha.com": "portinha",
  
  "circuitosertao.com": "sertao",
  "www.circuitosertao.com": "sertao",
};

function App() {
  const hostname = window.location.hostname;
  const domainSlug = customDomains[hostname]; // Se achar, pega o slug "portinha"

  return (
    <UserProvider>
      <Router>
        <ScrollToTop /> 
        <Routes>
          
          {/* ==============================================================
              🚀 1. ROTAS DO DOMÍNIO EXCLUSIVO (campeonatoportinha.com)
              ============================================================== */}
          {domainSlug && (
            <>
              {/* O Painel do Circuito (dominio.com/painel) */}
              <Route path="/painel/*" element={<LayoutPainelCircuito customSlug={domainSlug} />}>
                 <Route path="login" element={<LoginPainelCircuito />} />
                 <Route index element={<DashboardCircuito />} />
                 <Route path="noticias" element={<CircuitoNoticiasPainel />} />
                 <Route path="campeoes" element={<CircuitoCampeoesPainel />} />
                 <Route path="patrocinadores" element={<CircuitoPatrocinadoresPainel />} />
                 <Route path="financeiro" element={<CircuitoFinanceiroPainel />} />
                 <Route path="etapas" element={<CircuitoEtapasPainel />} />
                 <Route path="despesas" element={<CircuitoDespesasPainel />} />
                 <Route path="cupons" element={<CircuitoCuponsPainel />} />
                 <Route path="afiliados" element={<CircuitoAfiliadosPainel />} />
                 <Route path="associados" element={<AssociadosCircuito />} />
                 <Route path="cavalos" element={<CircuitoCavalos />} />
                 <Route path="ranking" element={<CircuitoRankingPainel />} />
                 <Route path="associados/editar/:id" element={<EditarAssociadoCircuito />} /> {/* 👈 ADICIONE AQUI */}
                 <Route path="regulamento" element={<CircuitoRegulamentoPainel />} />
                 <Route path="transmissao" element={<TransmissaoCircuito />} />
              </Route>

              {/* A Página do Vaqueiro (campeonatoportinha.com) */}
              <Route path="/*" element={<LayoutCircuito customSlug={domainSlug} />}>
                <Route index element={<CircuitoHomeV2 />} />
                <Route path="etapas" element={<CircuitoEtapas />} />
                <Route path="regulamento" element={<CircuitoRegulamento />} />
                <Route path="ranking" element={<CircuitoRanking />} />
                <Route path="inscrever-se" element={<CircuitoInscreverSe />} />
                <Route path="inscrever-se/acesso" element={<CircuitoInscricaoAcesso />} />
                <Route path="inscrever-se/cadastro" element={<CircuitoInscricaoCadastro />} />
                <Route path="inscrever-se/dados" element={<CircuitoInscricaoDados />} />
                <Route path="inscrever-se/pagamento" element={<CircuitoInscricaoPagamento />} />
                <Route path="associacao-concluida/:pedidoId" element={<CircuitoInscricaoSucesso />} />
                <Route path="noticias/:noticiaId" element={<CircuitoNoticiaDetalhe />} />
                <Route path="minha-associacao" element={<MinhaAssociacaoCircuito />} />
                <Route path="noticias" element={<CircuitoNoticiasLista />} />
                <Route path="afiliado/:codigo" element={<CircuitoAfiliadoDashboard />} />
                <Route path="recuperar-senha" element={<RecuperarSenhaCircuito />} />
                <Route path="resetar-senha/:token" element={<ResetarSenhaCircuito />} />
                <Route path="carteirinha" element={<CircuitoCarteirinha />} />
              </Route>
            </>
          )}

          {/* ==============================================================
              🌐 2. ROTAS PADRÃO DA TICKET DO VAQUEIRO 
              ============================================================== */}
          {!domainSlug && (
            <>
              {/* O Painel do Circuito (ticketdovaqueiro.com/painel-circuito/slug) */}
              <Route path="/painel-circuito/:slug/*" element={<LayoutPainelCircuito />}>
                <Route index element={<DashboardCircuito />} />
                <Route path="login" element={<LoginPainelCircuito />} />
                <Route path="noticias" element={<CircuitoNoticiasPainel />} />
                <Route path="campeoes" element={<CircuitoCampeoesPainel />} />
                <Route path="patrocinadores" element={<CircuitoPatrocinadoresPainel />} />
                <Route path="financeiro" element={<CircuitoFinanceiroPainel />} />
                <Route path="etapas" element={<CircuitoEtapasPainel />} />
                <Route path="afiliados" element={<CircuitoAfiliadosPainel />} />
                <Route path="associados" element={<AssociadosCircuito />} />
                <Route path="cavalos" element={<CircuitoCavalos />} />
                <Route path="ranking" element={<CircuitoRankingPainel />} />
                <Route path="despesas" element={<CircuitoDespesasPainel />} />
                <Route path="cupons" element={<CircuitoCuponsPainel />} />
                <Route path="regulamento" element={<CircuitoRegulamentoPainel />} />
                <Route path="associados/editar/:id" element={<EditarAssociadoCircuito />} /> 
                <Route path="transmissao" element={<TransmissaoCircuito />} />   
               </Route>

              {/* A Página do Vaqueiro (ticketdovaqueiro.com/circuito/slug) */}
              <Route path="/circuito/:slug/*" element={<LayoutCircuito />}>
                <Route index element={<CircuitoHomeV2 />} />
                <Route path="etapas" element={<CircuitoEtapas />} />
                <Route path="regulamento" element={<CircuitoRegulamento />} />
                <Route path="ranking" element={<CircuitoRanking />} />
                <Route path="inscrever-se" element={<CircuitoInscreverSe />} />
                <Route path="inscrever-se/acesso" element={<CircuitoInscricaoAcesso />} />
                <Route path="inscrever-se/cadastro" element={<CircuitoInscricaoCadastro />} />
                <Route path="inscrever-se/dados" element={<CircuitoInscricaoDados />} />
                <Route path="inscrever-se/pagamento" element={<CircuitoInscricaoPagamento />} />
                <Route path="associacao-concluida/:pedidoId" element={<CircuitoInscricaoSucesso />} />
                <Route path="noticias/:noticiaId" element={<CircuitoNoticiaDetalhe />} />
                <Route path="minha-associacao" element={<MinhaAssociacaoCircuito />} />
                <Route path="noticias" element={<CircuitoNoticiasLista />} />
                <Route path="afiliado/:codigo" element={<CircuitoAfiliadoDashboard />} />
                <Route path="recuperar-senha" element={<RecuperarSenhaCircuito />} />
                <Route path="carteirinha" element={<CircuitoCarteirinha />} />
                <Route path="resetar-senha/:token" element={<ResetarSenhaCircuito />} />
              </Route>

              <Route path="profissionais/acesso" element={<ProfissionalAcesso />} />
              <Route path="/*" element={<LayoutPrincipal />} />
              <Route path="/admin/*" element={<LayoutAdmin />} />
              <Route path="/dono/*" element={<LayoutDono />} />
            </>
          )}

        </Routes>
      </Router>
    </UserProvider>
  );
}
export default App;

/* 🔹 LAYOUT COM MENU E RODAPÉ (SITE NORMAL) */
const LayoutPrincipal = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/eventos" element={<Eventos />} />
        <Route path="/evento/:id" element={<DetalhesEvento />} />
        <Route path="/carrinho" element={<Carrinho />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/compra-passo-1" element={<CompraPasso1 />} />
        <Route path="/compra-passo-2" element={<CompraPasso2 />} />
        <Route path="/compra-passo-3" element={<CompraPasso3 />} />
        <Route path="/resumo-pedido" element={<ResumoPedido />} />
        <Route path="/pagamento" element={<Pagamento />} />
        <Route path="/compra/confirmacao" element={<Confirmacao />} />
        <Route path="/meus-pedidos" element={<MeusPedidos />} />
        <Route path="/meus-boletos" element={<MeusBoletos />} />
        <Route path="/cartao" element={<CheckoutCartao />} />
        <Route path="/quem-somos" element={<QuemSomos />} />
        <Route path="/como-contratar" element={<ComoContratar />} />
        <Route path="/pedido/concluido/:pedidoId" element={<ConfirmacaoPagamento />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/resetar-senha/:token" element={<ResetarSenha />} />
        <Route path="/politica-cancelamento" element={<PoliticaCancelamento />} />
        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/meus-dados" element={<PerfilUsuario />} />
        <Route path="/vaquejadas" element={<Vaquejadas />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/ranking/:id" element={<RankingDetalhes />} />
        <Route path="/transferir-senha" element={<TransferirSenha />} />
        <Route path="/mapa-compartilhado/:eventoId/:categoriaNome" element={<MapaCompartilhado />} />
        {/* ✅ NOVO PAINEL */}
        <Route path="/painel" element={<PainelEntrada />} />
        <Route path="/painel/rodizio" element={<PainelRodizio />} />
        <Route path="/painel/disputa" element={<PainelDisputa />} />
        {/* ✅ TELÃO / PLACAR */}
        <Route path="/painel/placar" element={<PainelPlacarEntrada />} />
        <Route path="/painel/placar/classificacao" element={<PlacarClassificacao />} />
        <Route path="/painel/placar/disputa" element={<PlacarDisputa />} />        


      </Routes>
      <Footer />
      <BotaoWhatsApp />
    </>
  );
};

/* 🔹 LAYOUT SEM NAVBAR E SEM FOOTER (ADMIN) */
const LayoutAdmin = () => {
  const token = localStorage.getItem("token");
    // ✅ SEGURO: não crasha se o dado estiver corrompido
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    localStorage.removeItem("user"); // limpa o dado corrompido
  }

  if (!token || user?.tipo !== "admin") {
    return <Navigate to="/login" />;
  }


  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <Routes>
          <Route path="dashboard" element={<DashboardAdmin />} />
          <Route path="eventos" element={<DashboardEventos />} />
          <Route path="marketing" element={<MarketingAdmin />} />
          <Route path="criar-evento" element={<CriarEvento />} />
          <Route path="avisos-admin" element={<AvisosAdmin />} />
          <Route path="parcelamentos" element={<PainelParcelamentos />} />
          <Route path="vendas" element={<VendasAdmin />} />
          <Route path="taxas" element={<TaxasAdmin />} /> 
          <Route path="despesas-circuitos" element={<DespesasCircuitoAdmin />} />
          <Route path="financeiro" element={<Financeiro />} /> 
          <Route path="financeiro-admin" element={<FinanceiroAdmin />} /> 
          <Route path="donos" element={<Donos />} /> 
          <Route path="despesas" element={<DespesasAdmin />} />
          <Route path="clientes" element={<Clientes />} /> 
          <Route path="editar-evento/:id" element={<EditarEvento />} />
          <Route path="relatorio" element={<RelatorioAdmin />} />
          <Route path="senhas-limpas" element={<SenhasLimpas />} />
          <Route path="circuitos" element={<CircuitosAdmin />} />
          <Route path="exportacao" element={<ExportacaoEventoAdmin />} />
          <Route path="gateways" element={<Gateways />} />
          <Route path="vales" element={<ValesAdmin />} />
          <Route path="descontos" element={<DescontosAdmin />} />
          <Route path="notificacao-app" element={<NotificacaoApp />} />
          <Route path="notificacao-whatsapp" element={<NotificacaoWhatsapp />} />
          <Route path="contabilidade" element={<ContabilidadeAdmin />} />
          <Route path="raspadinha" element={<RaspadinhaAdmin />} />
          <Route path="raspadinha-vendas" element={<RaspadinhaVendasAdmin />} />
          <Route path="patrocinadores" element={<PatrocinadoresAdmin />} />
          <Route path="profissionais" element={<ProfissionaisAdmin />} />
          <Route path="financeiro-circuitos" element={<FinanceiroCircuitoAdmin />} />
          <Route path="afiliados" element={<AfiliadosAdmin />} />
          <Route path="transmissoes" element={<GerenciarTransmissoes />} />
        </Routes>
      </div>
      <BotaoWhatsApp />
    </div>
  );
};

/* 🔹 LAYOUT SEM NAVBAR E SEM FOOTER (DONO) */
const LayoutDono = () => {
  const token = localStorage.getItem("token");
  // ✅ SEGURO
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    localStorage.removeItem("user");
  }

  if (!token || user?.tipo !== "dono") {
    return <Navigate to="/login" />;
  }
  

  return (
    <div className="dono-layout">
      <SidebarDono />
      
        <Routes>
          <Route path="dashboard" element={<DashboardDono />} />
          <Route path="criar-evento" element={<CriarEvento />} />
          <Route path="vendas" element={<VendasDono />} /> {/* NOVA ROTA ADICIONADA */}
          <Route path="financeiro-dono" element={<FinanceiroDono />} />
          <Route path="relatorio" element={<RelatorioDono />} />
          <Route path="notificacoes" element={<ConfigPushcut />} />
          <Route path="senhas-limpas" element={<SenhasLimpasDono />} />
        </Routes>
        <BotaoWhatsApp />
    </div>
  );
};
